import { LoadPanel, Scheduler } from 'devextreme-react';
import getLoggedUser from 'helpers/userFunctions';
import React from 'react';
import useUserSchedule from 'services/requests/useUserSchedule';
import AppointmentCell from './appointment-cell';
import { Editing } from 'devextreme-react/scheduler';

export default function AppSchedule() {
  const userId = getLoggedUser();
  const { data, isLoading } = useUserSchedule(userId);

  return (
    <div>
      <LoadPanel
        shadingColor="rgba(255,255,255,0.4)"
        visible={isLoading}
        message='Loading...'
        closeOnOutsideClick={false}
      />
      <Scheduler
        dataSource={data ?? []}
        currentView="agenda"
        appointmentComponent={AppointmentCell}
        views={['agenda']}
        allDayExpr='AllDay'
        textExpr='Description'
        startDateExpr='StartDate'
        endDateExpr='EndDate'                
        showAllDayPanel
        adaptivityEnabled
      >
        <Editing
          allowAdding={false}
          allowDeleting={false}
          allowDragging={false}
          allowResizing={false}
          allowUpdating={false}
        />
      </Scheduler>

    </div>
  )
}